import { useRoomCanMakeLive } from '$logic/hall/react-hook'
import { IconButton } from '@mui/material'
import { LiveIcon, MeetIcon } from '$common/icons'
import { RoomTypes } from '@weblite/ts-action/room'

export function HallAppBarCallElement({
  roomId,
  onClick,
  roomType,
}: {
  roomId: string
  onClick: () => void
  roomType: Extract<RoomTypes, 'CHANNEL' | 'GROUP'>
}) {
  const { canMakeLive } = useRoomCanMakeLive(roomId)

  return canMakeLive ? (
    <IconButton
      sx={{
        marginLeft: '4px',
      }}
      onClick={onClick}
    >
      {roomType === 'GROUP' ? (
        <MeetIcon sx={{ color: 'neutral700' }} />
      ) : (
        <LiveIcon sx={{ color: 'neutral700' }} />
      )}
    </IconButton>
  ) : null
}
